module.exports = __webpack_public_path__ + "static/lastgen-slr-trees-f29bb22a3764fe61c861dfd5ff2544c9.mp4";